    <div *ngIf="foldseekapiService.pdbZeroResultsMsg() !== ''" class="threedViewer structureContainer mobile-error-msg fullwidth">
        <p *ngIf="foldseekService.hasPDBData() === -1 && foldseekapiService.totalStructure() == 0" class="noRecMsg">{{ foldseekapiService.pdbZeroResultsMsg() }} </p>
    </div>

    <div class="download-first-row" *ngIf="foldseekapiService.pdbZeroResultsMsg() === ''">
        <div class="link-button-download" class="structureContainer-1">
            <div class="download-data nonMobile"  *ngIf="foldseekapiService.isPDBDownloadEnabled() === true && foldseekService.isPDBLoading() === false">
                <div  style="display: flex;" *ngIf="!downloadService.isDownloadRunningPDB() || downloadService.isDownloadFailedPDB()">
                    <app-file-download
                      [isWide]="true"
                      [dropdownOptions]="dropdownOptionsPDB"
                      (selected)="foldseekapiService.handleDropdownSelection($event,'pdb')"
                      [selectedValues]="selectedValuesPDB()">
                    </app-file-download>
                    <div class="downloadselectedtext" *ngIf="selectedValuesPDB().length > 0"> 
                      <span class="maxselected selectedtext">{{ selectedValuesPDB().length }} selected (max {{ MAX_SELECTION }})</span> 
                      <a href="javascript:void(0)" (click)="foldseekapiService.clearSelectionDownload('pdb')" class="resetLink selectedtext clearselected">Clear selection</a>
                    </div>
                  </div>
                  <div *ngIf="downloadService.isDownloadRunningPDB() && !downloadService.isDownloadFailedPDB()" style="display: flex;" > 
                    <span style="display: inline-block; width: 20px; margin-left: 8px;">
                      <svg  width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z" class="spinner_aj0A" stroke="#707372" fill="#707372" />
                      </svg>
                    </span> <span class="selectedtext">Download in progress</span>
                </div>
            </div>
        </div>

        <div class="threedViewer structureContainer filterWrapper">
            
            <div style="position: relative">
              <input
                #filterBox
                class="vf-form__input searchLine"
                autocomplete="off"
                placeholder="Search species"
                (keyup.enter)="foldseekapiService.filterTable(filterBox.value, 'pdb')"
                id="filteritemPDB"
                [(value)]="filteritemPDB"
              />
              <span
                *ngIf="filterBox.value === ''"
                class="filtericon"
                (click)="foldseekapiService.filterTable(filterBox.value, 'pdb')"
              >
                <img src="assets/img/Search.svg" alt="filter" />
              </span>
      
              <span
                *ngIf="filterBox.value !== ''"
                class="filtericon"
                (click)="foldseekapiService.clearFilter('pdb')"
              >
                <img src="assets/img/crossicon.svg" alt="filter"/>
              </span>
            </div>
        </div>
        
    </div>
   
    <div  *ngIf="foldseekapiService.pdbZeroResultsMsg() === ''">

        <table
            mat-table
            [dataSource]="foldseekapiService.pdbStructureDataSource()"
            class="mat-elevation-z8 structureTable"
            matSort
            matSortActive="evalue"
            matSortDirection="desc"
            (matSortChange)="foldseekapiService.sortTable($event, 'pdb')"
            matSortDisableClear
            multiTemplateDataRows
        >
        
        <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef class="nonMobile">
              <input
                type="checkbox"
                id="select-all-checkbox"
                class="vf-form__checkbox"
                [checked]="allSelectedPDB()"
                [disabled]="foldseekapiService.isLimitReachedPDB()"
                (change)="foldseekapiService.toggleSelectAllEntries($event, 'pdb')"
              />
              <label for="select-all-checkbox" class="vf-form__label"></label>
            </th>
            <td mat-cell *matCellDef="let element" class="nonMobile">
                <input
                type="checkbox"
                id="row-checkbox-{{ element.targetToShow }}"
                class="vf-form__checkbox"
                [checked]="foldseekapiService.selectionPDB().has(element.targetToShow)"
                [disabled]="foldseekapiService.isRowCheckboxDisabledPDB() && !foldseekapiService.selectionPDB().has(element.targetToShow)"
                (change)="foldseekapiService.toggleSingleRowSelection($event, element.targetToShow, 'pdb')"
              />
              <label for="row-checkbox-{{ element.targetToShow }}" class="vf-form__label"></label>
            </td>
        </ng-container>

        <ng-container matColumnDef="expand">
            <th class="firstexpandpdb arrow" mat-header-cell *matHeaderCellDef></th>
            <td  mat-cell *matCellDef="let element" class="arrow-box" [ngClass]="!isExpanded(element) ? '' : 'arrow-active'">
                <div class="nonMobile">
                    <button (click)="toggleRowPDB(element); $event.stopPropagation()"  mat-icon-button aria-label="expand row" class="nonMobile icon-button">
                        <img *ngIf="!isExpanded(element)" src="assets/img/ep_arrow-up-bold.svg" alt="uparrow" class="unchecked-icon">
                        <img *ngIf="isExpanded(element)" src="assets/img/arrow_drop_down_24px.svg" alt="downarrow" class="unchecked-icon">
                    </button>
                </div>
                <div class="mobile-view">
                    <div class="mobile-wrapfirsttd">
                        <button (click)="toggleRowPDB(element); $event.stopPropagation()"  mat-icon-button aria-label="expand row" class="icon-button">
                            <span *ngIf="!isExpanded(element)" class="mobile-arrow-title-text"> Open pairwise alignment  <img *ngIf="!isExpanded(element)" src="assets/img/down-arrow.svg" alt="uparrow" class="newimg"></span>
                            <span *ngIf="isExpanded(element)" class="mobile-arrow-title-text"> Close pairwise alignment   <img  src="assets/img/arrow-dropping.svg" alt="downarrow" class="newimg"></span>

                        </button>

                        <div class="mobile-align-3d">
                            <span class="mobile-arrow-title align3d-for-mobile"> Align in 3D </span>
                            <div class="switch-af">
                                <input type="checkbox" [disabled]="disabledState[element.afdbAccessions.split('*')[0]] || false" [checked]="checkboxState[element.afdbAccessions.split('*')[0]] || false" id="{{element.afdbAccessions.split('*')[0]}}" value="{{element.afdbAccessions.split('*')[0]}}" (change)="clickToggleSuperpose($event,element.afdbAccessions.split('*')[0])" />
                                <label for="{{element.afdbAccessions.split('*')[0]}}">
                                
                                <img src="../../assets/img/FatX.svg" alt="FatX" class="unchecked-icon">
                                <img src="../../assets/img/base-switch_icon.svg" alt="check" class="checked-icon">

                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumnsStructureWithExpand.length" class="expand-column">
              <div class="example-element-detail" *ngIf="isExpanded(element)">
                <app-sequence-card [hsps]="element.hsps" [isExpandStructure]="true"></app-sequence-card>
              </div>
            </td>
        </ng-container>
        
       
        <ng-container matColumnDef="afdbAccessions">
            <th class="first-pdbid" mat-header-cell *matHeaderCellDef>
               <span>PDB ID <br>and chain</span>
            </th>
            <td mat-cell *matCellDef="let element">
            <span class="mobile-view mobile-view-title">PDB ID and <br>chain</span>
            <span *ngIf="element.afdbAccessions === 'Unavailable'"
                >{{ element.targetToShow }} 
                <span class="mobile-view"><br></span>  
                {{ element.uniprotDescriptions }}
            </span>

            <span
                class="titleBadges"
                *ngIf="element.afdbAccessions !== 'Unavailable'">
                <a class="pdbid" (click)= "gaService.eventEmitter(
            'foldseek_clickthrough', 'FS_similar_structures', 'click', 'foldseek_PDB_url', 'Clicks on PDB URLs in the Foldseek results table')" href="{{element.refLinkId}}" target="_blank">{{ element.targetToShow }}</a>
                
            </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="descriptions">
            <th class="sec-desc" mat-header-cell *matHeaderCellDef>Description</th>
            <td mat-cell *matCellDef="let element">
           
            <span class="mobile-view mobile-view-title">Description</span>
            <span class="mobile-view"> <div class="
                 moreinfo" appDescription [descriptionData]="element.uniprotDescriptions" [isMobileDesc]="true"> </div> </span>

            <div class="nonMobile moreinfo" appDescription [descriptionData]="element.uniprotDescriptions" [isMobileDesc]="false"> </div>
           
            </td>
        </ng-container>

        <ng-container matColumnDef="speciesNames">
            <th class="third-species" mat-header-cell *matHeaderCellDef>Species</th>
            <td mat-cell *matCellDef="let element">
           
            <span class="mobile-view mobile-view-title">Species</span>
            <span class="mobile-view"> <i> <div class=" moreinfo" appDescription [descriptionData]="element.speciesNames" [isMobileDesc]="true"> </div></i> </span>
            
            <i><div class="nonMobile moreinfo" appDescription [descriptionData]="element.speciesNames" [isMobileDesc]="false"> </div></i>
            </td>
        </ng-container>

        <ng-container matColumnDef="sequenceLength">
            <th class="fourth-range" mat-header-cell *matHeaderCellDef>
                Residue <br/>range
            </th>
            <td mat-cell *matCellDef="let element">
            <span class="mobile-view mobile-view-title">Residue range</span>
                <div class="moreinforesidue" appResidueRange [residueData]="element.sequenceLength"></div>
            </td>
        </ng-container>

        <ng-container matColumnDef="evalue">
            <th class="eval" mat-header-cell *matHeaderCellDef mat-sort-header="evalue">
                E-value
                <div class="label-tooltip" style="display: flex; flex-direction: row;">
                     <svg class="que-svg" viewBox="0 0 24 24">
                     <path fill="#373A36"
                             d="M11,18H13V16H11V18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,6A4,4 0 0,0 8,10H10A2,2 0 0,1 12,8A2,2 0 0,1 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10A4,4 0 0,0 12,6Z"/>
                     </svg>
                     <span class="label-header-tooltip-text" style="font-size: 14px; font-weight: 400; text-align: left;">
                        Likelihood of a match between <br>the query and target sequence <br> in a structural alignment. <br>The lower the E-value, the more<br> significant the alignment. 
                     </span>
                 </div>
            </th>
            <td mat-cell *matCellDef="let element">
                <div class="mobile-view mobile-view-title">
                    <div style="display: flex; flex-direction: row;">
                        E-value
                        <div class="label-tooltip">
                            <svg class="que-svg" viewBox="0 0 24 24">
                                <path fill="#373A36"
                                        d="M11,18H13V16H11V18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,6A4,4 0 0,0 8,10H10A2,2 0 0,1 12,8A2,2 0 0,1 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10A4,4 0 0,0 12,6Z"/>
                            </svg>
                            <span class="label-header-tooltip-text" style="font-size: 14px; font-weight: 400; text-align: left;">
                                Likelihood of a match between <br>the query and target sequence <br> in a structural alignment. <br>The lower the E-value, the more<br> significant the alignment. 
                            </span>
                        </div>
                    </div>
                </div>
                {{ element.evalue }}
            </td>
        </ng-container>
        <ng-container matColumnDef="sequenceIdentity">
            <th class="seq-identity" mat-header-cell *matHeaderCellDef  mat-sort-header>
                <div style="display: flex; flex-direction: row; align-items:end;">
                    Seq. <br>identity
                    <div class="label-tooltip-res">
                        <svg class="que-svg" viewBox="0 0 24 24">
                        <path fill="#373A36"
                                d="M11,18H13V16H11V18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,6A4,4 0 0,0 8,10H10A2,2 0 0,1 12,8A2,2 0 0,1 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10A4,4 0 0,0 12,6Z"/>
                        </svg>
                        <span class="label-tooltip-text-res" style="font-size: 14px; font-weight: 400; text-align: left;">
                            Percentage of identical <br>residues between aligned <br>sequences over the<br> aligned length.
                        </span>
                    </div>
                </div>
               
            </th>
            <td mat-cell *matCellDef="let element">
                <span class="mobile-view mobile-view-title">
                    <div style="display: flex; flex-direction: row; align-items:end;">
                    Seq. identity
                        <div class="label-tooltip">
                            <svg class="que-svg" viewBox="0 0 24 24">
                            <path fill="#373A36"
                                    d="M11,18H13V16H11V18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,6A4,4 0 0,0 8,10H10A2,2 0 0,1 12,8A2,2 0 0,1 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10A4,4 0 0,0 12,6Z"/>
                            </svg>
                            <span class="label-header-tooltip-text" style="font-size: 14px; font-weight: 400; text-align: left;">
                                Percentage of identical <br>residues between aligned <br>sequences over the<br> aligned length.
                            </span>
                        </div>
                    </div>
                </span>
            {{ element.sequenceIdentity }}%
            </td>
        </ng-container>

        <ng-container matColumnDef="resolution">
            <th class="seventh-res thirdid" mat-header-cell *matHeaderCellDef>
                Res.
                <div style="display: flex;"> (Å)
                    <div class="label-tooltip-res" style="display: flex; flex-direction: row;">
                       
                        <svg class="que-svg" viewBox="0 0 24 24">
                        <path fill="#373A36"
                                d="M11,18H13V16H11V18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,6A4,4 0 0,0 8,10H10A2,2 0 0,1 12,8A2,2 0 0,1 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10A4,4 0 0,0 12,6Z"/>
                        </svg>
                        <span class="label-tooltip-text-res" style="font-size: 14px; font-weight: 400; text-align: left;">
                            Resolution. Indicates the level <br>of detail present in the 3D  <br>structure. Smaller value means  <br>finer details of the  structure<br> and higher quality.
                        </span>
                    </div>
                </div>
            </th>
            <td mat-cell *matCellDef="let element">
                <span class="mobile-view mobile-view-title"> 
                    <div style="display: flex; flex-direction: row; align-items: end;">
                        Resolution (Å)
                        <div class="label-tooltip">
                            <svg class="que-svg" viewBox="0 0 24 24">
                                <path fill="#373A36"
                                        d="M11,18H13V16H11V18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,6A4,4 0 0,0 8,10H10A2,2 0 0,1 12,8A2,2 0 0,1 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10A4,4 0 0,0 12,6Z"/>
                            </svg>
                            <span class="label-header-tooltip-text" style="font-size: 14px; font-weight: 400; text-align: left;">
                                Resolution. Indicates the level <br>of detail present in the 3D  <br>structure. Smaller value means  <br>finer details of the  structure<br> and higher quality.
                            </span>
                        </div>
                    </div>
                </span>
                {{ element.resolution }}
            </td>
        </ng-container>

        <ng-container matColumnDef="alighin3D">
            <th class="eight-align" mat-header-cell *matHeaderCellDef>
                Align <br/>in 3D
            </th>
            <td mat-cell *matCellDef="let element" class="align3dfor-nonmobile">
                <div class="switch-af nonMobile">
                    <input type="checkbox" [disabled]="disabledState[element.afdbAccessions.split('*')[0]] || false" [checked]="checkboxState[element.afdbAccessions.split('*')[0]] || false" id="{{element.afdbAccessions.split('*')[0]}}" value="{{element.afdbAccessions.split('*')[0]}}" (change)="clickToggleSuperpose($event,element.afdbAccessions.split('*')[0]); $event.stopPropagation();" />
                    <label (click)="$event.stopPropagation();" for="{{element.afdbAccessions.split('*')[0]}}">
                    
                    <img src="../../assets/img/FatX.svg" alt="FatX" class="unchecked-icon">
                    <img src="../../assets/img/base-switch_icon.svg" alt="check" class="checked-icon">

                    </label>
                </div>
            </td>
        </ng-container>
       
        <tr mat-header-row *matHeaderRowDef="displayedColumnsStructureWithExpand"></tr>
        <tr mat-row *matRowDef="let element; columns: displayedColumnsStructureWithExpand;"
            class="example-element-row"
            [ngClass]="isExpanded(element) ? 'example-expanded-row' : ''" 
            
            (click)="expandRow(element)">
        </tr>
        
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
        
        <ng-container *ngFor="let row of foldseekapiService.pdbStructureDataSource()?.data">
            <ng-container *ngIf="isExpanded(row)" >
              <tr mat-row *matRowDef="let row; columns: ['expandedDetail']; when: isExpansionDetailRow" class="example-detail-row"></tr>
            </ng-container>
        </ng-container>

    </table>
        
    </div>
    
    <div  *ngIf="foldseekapiService.pdbZeroResultsMsg() === ''" class="threedViewer structureContainer">
        <p *ngIf="foldseekService.hasPDBData() === -1 && foldseekapiService.totalStructure() == 0" class="noRecMsg">{{ foldseekapiService.errorPDB() }}</p>
    </div>
    
    <div *ngIf="foldseekapiService.pdbZeroResultsMsg() === ''">
        <mat-paginator
            [length]="foldseekapiService.totalStructure()"
            [pageSize]="foldseekapiService.recordsPDB()"
            [pageIndex]="foldseekapiService.currentPDBPage()"
            [pageSizeOptions]="[5, 10, 25, 50, 100]"
            aria-label="Select page"
            (page)="foldseekapiService.handlePageEvent($event,'pdb')"
        >
        </mat-paginator>
    </div> 
